uniform vec3 uColor;
uniform float uInnerRadius;
uniform float uOuterRadius;
uniform float uAlpha; // 本体と一緒にフェードイン
uniform float uGlow;  // ゾーン発動中の増光（0-1）
uniform float uTime;

varying vec2 vLocalPos;

/*
 * 土星のリング。半径方向の縞模様＋カッシーニの間隙。
 * 自己発光（暗いイントロでも見える）で、uGlow で発動中に増光する。
 */
void main()
{
    float radius = length(vLocalPos);
    // リング内での正規化位置（0 = 内縁, 1 = 外縁）
    float t = (radius - uInnerRadius) / (uOuterRadius - uInnerRadius);

    if (t < 0.0 || t > 1.0) discard;

    // 半径方向の細かい縞（周波数の違う縞を重ねる）
    float bands = 0.75
        + 0.25 * sin(t * 60.0)
        + 0.15 * sin(t * 23.0 + 1.7);

    // カッシーニの間隙（t ≈ 0.62 に暗い溝）
    float cassini = 1.0 - 0.85 * exp(-pow((t - 0.62) / 0.035, 2.0));

    // 内縁・外縁をなだらかに減衰
    float edgeFade = smoothstep(0.0, 0.08, t) * (1.0 - smoothstep(0.85, 1.0, t));

    // 密度（明るさ兼アルファ）
    float density = bands * cassini * edgeFade;

    // 発動中はきらめきながら増光
    float shimmer = 1.0 + uGlow * (0.8 + 0.2 * sin(uTime * 3.0 + t * 40.0));

    vec3 color = uColor * density * shimmer;

    gl_FragColor = vec4(color, density * uAlpha);
}
